import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDishes = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: "24px",
	height: "24px",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			d: "M1.82,0.002C1.225-0.032,0.66,0.356,0.501,0.953 L0.279,1.78c-0.558,2.084-0.246,4.195,0.703,5.959c0.101-0.015,0.201-0.024,0.305-0.024h18c0.221,0,0.431,0.044,0.632,0.107 c0.087-0.234,0.167-0.472,0.232-0.717l0.222-0.828c0.182-0.681-0.229-1.393-0.91-1.575L2.076,0.043 C1.99,0.02,1.905,0.007,1.82,0.002L1.82,0.002z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			d: "M1.286,8.571C0.581,8.571,0,9.152,0,9.857v0.857 c0,2.802,1.421,5.276,3.581,6.742l16.661-4.464c0.211-0.723,0.33-1.486,0.33-2.277V9.857c0-0.705-0.581-1.286-1.286-1.286H1.286 L1.286,8.571z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			d: "M22.549,13.289c-0.084,0.005-0.17,0.018-0.254,0.041 L4.863,18h17.851c0.037,0,0.073,0.004,0.109,0.006c0.971-0.944,1.419-2.372,1.045-3.768C23.709,13.643,23.144,13.254,22.549,13.289 L22.549,13.289z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			d: "M1.286,18.858C0.581,18.858,0,19.438,0,20.143 C0,22.269,1.732,24,3.857,24h16.286C22.268,24,24,22.269,24,20.143c0-0.705-0.581-1.285-1.285-1.285H1.286z"
		})
	]
});
export default SvgDishes;
